export function randomId() {
  return `cassini-${Math.random().toString(36).slice(2, 11)}`;
}
